var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-textarea',{ref:"textarea",staticClass:"grid-title-textarea",attrs:{"id":_vm.id || null,"name":_vm.name || null,"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"rows":"1","no-resize":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }